import UserInfo, { UserInfoProps } from './UserInfo';

export type { UserInfoProps };
export default UserInfo;
